import { supabase } from '../lib/supabase';

// Helper: Convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = typeof obj?.[key] === 'object' ? toCamelCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

// Helper: Convert camelCase to snake_case
const toSnakeCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, (letter) => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = typeof obj?.[key] === 'object' ? toSnakeCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

// Get today's content
export const getTodaysContent = async () => {
  try {
    const { data, error } = await supabase?.from('daily_content')?.select('*')?.eq('scheduled_date', new Date()?.toISOString()?.split('T')?.[0])?.eq('is_active', true)?.order('created_at', { ascending: false })?.limit(1)?.maybeSingle();

    if (error) throw error;
    return { data: toCamelCase(data), error: null };
  } catch (error) {
    console.error('Error fetching today content:', error);
    return { data: null, error };
  }
};

// Get all content (for admin)
export const getAllContent = async () => {
  try {
    const { data, error } = await supabase?.from('daily_content')?.select('*')?.order('scheduled_date', { ascending: true });

    if (error) throw error;
    return { data: data?.map(toCamelCase), error: null };
  } catch (error) {
    console.error('Error fetching all content:', error);
    return { data: [], error };
  }
};

// Create or update content
export const saveContent = async (contentData) => {
  try {
    const snakeData = toSnakeCase(contentData);
    
    if (snakeData?.id) {
      // Update existing
      const { data, error } = await supabase?.from('daily_content')?.update(snakeData)?.eq('id', snakeData?.id)?.select()?.single();

      if (error) throw error;
      return { data: toCamelCase(data), error: null };
    } else {
      // Insert new
      const { data, error } = await supabase?.from('daily_content')?.insert(snakeData)?.select()?.single();

      if (error) throw error;
      return { data: toCamelCase(data), error: null };
    }
  } catch (error) {
    console.error('Error saving content:', error);
    return { data: null, error };
  }
};

// Delete content
export const deleteContent = async (contentId) => {
  try {
    const { error } = await supabase?.from('daily_content')?.delete()?.eq('id', contentId);

    if (error) throw error;
    return { error: null };
  } catch (error) {
    console.error('Error deleting content:', error);
    return { error };
  }
};